import React, { memo } from 'react';
import PropTypes from 'prop-types';

const CustomYAxisTick = ({ x, y, payload }) => (
  <g transform={`translate(${x},${y})`} className="custom-y-axis-tick">
    <text x={0} y={0} dx={-10}>
      {payload.value}
    </text>
  </g>
);

CustomYAxisTick.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number,
  payload: PropTypes.shape({
    value: PropTypes.any,
  }),
};

export default memo(CustomYAxisTick);
